let JobData = [{
                title: "Job Title",
                company: "Beanget It solution pvt.Ltb..",
                location: "India,Mumbai",
                Experience: "0-2 Year",
                category: "Big Brands",
                CTC: "1000-2000",
                StartDate: "Immediately",
        },

        {
                title: "Job Title",
                company: "L&T Technology Services",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately",
            

        },

        {
                title: "Job Title",
                company: "Oracle Financial Services Software",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately",
            
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately"


        }
        ,
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately"


        },{
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately"


        },{
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                CTC: "2000-3000",
                StartDate: "Immediately"


        }
];

export default JobData;